import { BackendFetch, Tolgee } from "@tolgee/react";
import { FormatIcu } from "@tolgee/format-icu";
import { LANGUAGES, DEFAULT_LANGUAGE } from "@/constants/languages";
import { TOLGEE_CDN_FETCH_TIMEOUT_MS } from "@/constants/tolgee";
import type { Language } from "@/types/interfaces/language";

type LocaleMessages = Record<string, string>;
type LocaleLoader = () => Promise<LocaleMessages>;

const staticData = Object.fromEntries(
  LANGUAGES.map(({ value }) => [
    value,
    () => fetch(`/locales/${value}.json`).then((r) => r.json()),
  ]),
) as Record<Language, LocaleLoader>;

const cdnPrefix = process.env.NEXT_PUBLIC_TOLGEE_CDN_PREFIX?.replace(/\/$/, "") ?? "";

const tolgeeBuilder = Tolgee().use(FormatIcu());

if (cdnPrefix) {
  tolgeeBuilder.use(
    BackendFetch({
      prefix: cdnPrefix,
      fallbackOnFail: true,
      timeout: TOLGEE_CDN_FETCH_TIMEOUT_MS,
    }),
  );
}

export const tolgee = tolgeeBuilder.init({
  defaultLanguage: DEFAULT_LANGUAGE,
  staticData,
});
